module.exports = __webpack_public_path__ + "img/default.60acc917.png";